import React from 'react';

type Props = {
    className?: string;
};

export const EyeIcon: React.FC<Props> = ({className}) => {
    return (
        <svg className={className} width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.9477 13.3672C13.9987 13.3672 15.6613 11.7045 15.6613 9.65357C15.6613 7.60259 13.9987 5.93994 11.9477 5.93994C9.89672 5.93994 8.23407 7.60259 8.23407 9.65357C8.23407 11.7045 9.89672 13.3672 11.9477 13.3672Z"
                fill="#C9C9C9"/>
            <path
                d="M22.4104 7.25683C20.9705 4.91167 17.695 0.977051 11.9463 0.977051C6.19759 0.977051 2.92216 4.91167 1.48219 7.25683C0.574295 8.7253 0.574295 10.5808 1.48219 12.0493C2.92216 14.3945 6.19759 18.3291 11.9463 18.3291C17.695 18.3291 20.9705 14.3945 22.4104 12.0493C23.3183 10.5808 23.3183 8.7253 22.4104 7.25683ZM11.9463 15.2235C8.86985 15.2235 6.37584 12.7295 6.37584 9.65305C6.37584 6.57658 8.86985 4.08258 11.9463 4.08258C15.0228 4.08258 17.5168 6.57658 17.5168 9.65305C17.5137 12.7282 15.0215 15.2204 11.9463 15.2235Z"
                fill="#C9C9C9"/>
        </svg>
    )
}